import { jsx as _jsx } from "react/jsx-runtime";
import ProfileContainer from "@components/profile-container";
import React from "react";
var Targets = function(param) {
    var guestData = param.guestData;
    return /*#__PURE__*/ _jsx(ProfileContainer, {
        guestData: guestData,
        type: "targets"
    });
};
export var __N_SSG = true;
export default Targets;
